import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { sessionLog, sessionTypes } from "./data";
import SessionLogCard from "../../SessionLogCard";
import { FaCaretDown } from "react-icons/fa";
import { addSessionLogApi, getSessionLogApi } from "../../../../api/api";
import moment from "moment";
import { Toast } from "../../toast/Toast";

export default function PatientLogModal({
  isVisible,
  setIsVisible,
  selectedUser,
}) {
  // states
  const [sessions, setSessions] = useState([]);
  const [totalDuration, setTotalDuration] = useState(0);
  const [dropdownShow, setDropdownShow] = useState(false);
  const [selectedType, setSelectedType] = useState("");
  const [formData, setFormData] = useState({
    date: "",
    timeStart: "",
    timeEnd: "",
    notes: "",
  });
  const [loading, setLoading] = useState("");

  const handleModal = () => {
    setIsVisible(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevUserData) => ({
      ...prevUserData,
      [name]: value,
    }));
  };

  const timeInputs = [
    {
      key: "timeStart",
      name: "Time start",
      value: formData.timeStart,
      type: "text",
      placeholder: "00:00 AM",
    },
    {
      key: "timeEnd",
      name: "Time end",
      value: formData.timeEnd,
      type: "text",
      placeholder: "00:00 PM",
    },
  ];

  useEffect(() => {
    getSessionLog();
  }, []);

  const getSessionLog = async () => {
    const result = await getSessionLogApi(selectedUser._id);
    setSessions(result);
    calculateTotalDuration(result);
  };

  const calculateTotalDuration = (sessions) => {
    const totalMinutes = sessions.reduce(
      (sum, session) => sum + session.duration,
      0
    );
    setTotalDuration(totalMinutes);
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    const bodyData = {
      ...formData,
      sessionType: selectedType,
      patientId: selectedUser._id,
    };
    bodyData["timeStart"] = moment(
      `1970-01-01T${bodyData.timeStart}:00`
    ).format();
    bodyData["timeEnd"] = moment(`1970-01-01T${bodyData.timeEnd}:00`).format();

    const res = await addSessionLogApi(bodyData);
    if (res.err) {
    } else {
      const newSessions = [...sessions, res];
      setSessions(newSessions);
      calculateTotalDuration(newSessions);
      Toast.fire({
        position: "top-end",
        icon: "success",
        title: "Added successfully",
      });
    }
  };

  const formatDuration = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours} hours, ${minutes} minutes`;
  };

  return (
    <Modal
      title={`${selectedUser.user.name} User’s Sessions`}
      open={isVisible}
      onOk={handleModal}
      width={1000}
      okButtonProps={{ style: { backgroundColor: "#1d4ed8" } }}
      okText="Ok"
      cancelButtonProps={{ style: { display: "none" } }}
      onCancel={handleModal}
    >
      <hr />
      <div className="flex mt-3 justify-between">
        <div className="w-[45%]">
          <p className="font-poppin mb-2">Total Time Spent with Patient:</p>
          <h1 className="text-[#6434FF] text-[28px] font-poppin font-bold">
            {formatDuration(totalDuration)}
          </h1>
          <p className="font-poppin text-[#484848] font-bold mt-4 mb-2">
            Session Log
          </p>
          <div className="border border-[#BBBBBB] rounded-xl">
            {sessions.map((log, index) => (
              <SessionLogCard log={log} key={index} />
            ))}
          </div>
        </div>
        <div className="border"></div>
        <div className="w-[45%] relative">
          <h2 className="font-poppin text-[18px] font-bold text-[#484848] mb-3">
            Add New Session Log
          </h2>
          <form onSubmit={handleAdd}>
            <div
              className="w-full border border-[#484848] px-3 h-[38px] rounded-full flex justify-between items-center cursor-pointer"
              onClick={() => setDropdownShow(!dropdownShow)}
            >
              <p className="font-poppin text-[14px] font-medium">
                {selectedType ? selectedType : "Session Type"}
              </p>
              <FaCaretDown className="ml-2 text-[16px]" />
            </div>
            {dropdownShow && (
              <div className="bg-white p-2 shadow-lg mt-2 rounded-md absolute w-[100%]">
                {sessionTypes.map((session, index) => (
                  <p
                    key={index}
                    className="border-b border-b-[484848] mb-2 pb-2 font-poppin text-[14px] cursor-pointer"
                    onClick={() => {
                      setSelectedType(session.type);
                      setDropdownShow(false);
                    }}
                  >
                    {session.title}
                  </p>
                ))}
              </div>
            )}

            <div className="mt-3">
              <h4 className="text-[14px] font-bold mb-2 font-poppin">Date</h4>
              <input
                type={"date"}
                defaultValue={formData.date}
                className="add_user_input w-full rounded-full"
                onChange={handleInputChange}
                required={true}
                name="date"
              />
            </div>
            <div className="flex justify-between mt-4">
              {timeInputs.map((input, index) => (
                <div key={index} className="w-[48%]">
                  <h4 className="text-[14px] font-bold mb-2 font-poppin">
                    {input.name}:
                  </h4>
                  <input
                    type={"time"}
                    placeholder={input.placeholder}
                    defaultValue={input.value}
                    className="add_user_input w-full rounded-full"
                    onChange={handleInputChange}
                    required={true}
                    name={input.key}
                  />
                </div>
              ))}
            </div>
            <div className="mt-4">
              <p className="text-[14px] font-poppin mb-3 font-bold">
                Session Notes
              </p>
              <div>
                <textarea
                  type={"text"}
                  placeholder={"Enter text here"}
                  defaultValue={formData.notes}
                  className="add_user_input w-full h-full min-h-[200px] p-2"
                  onChange={handleInputChange}
                  required={true}
                  name="notes"
                />
              </div>
            </div>
            <div className="flex justify-center items-center mt-4">
              <button className="bg-[#6434FFB8] flex h-[48px] w-[80%] justify-center items-center text-[18px] text-white rounded-lg">
                Add
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
